import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "events-list"
}
const _hoisted_6 = {
  key: 2,
  class: "text-caption pl-2"
}
const _hoisted_7 = {
  key: 3,
  class: "text-caption pl-2"
}
const _hoisted_8 = { class: "user-icon" }
const _hoisted_9 = { class: "user-letter" }
const _hoisted_10 = { class: "user-msg mt-2 mb-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "text-overline"
}
const _hoisted_13 = { ref: "pre" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "chat-bubble"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.eventsDisplay && _ctx.userMessage != null)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "msg my-2"
        }, {
          default: _withCtx(() => [
            (_ctx.allSteps.completed)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "expand-btn",
                  icon: _ctx.show ? 'mdi-chevron-up' : 'mdi-chevron-down',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = !_ctx.show)),
                  variant: "text",
                  size: "x-large"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_title, { class: "mb-n4" }, {
              default: _withCtx(() => [
                (!_ctx.allSteps.completed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Analyzing " + _toDisplayString(_ctx.userMessage) + "...", 1))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = !_ctx.show)),
                      class: "clickable d-block mr-8"
                    }, "Analysis of " + _toDisplayString(_ctx.userMessage) + " completed in " + _toDisplayString(_ctx.getTimeElapsed(_ctx.allSteps.started, _ctx.allSteps.finished)), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_expand_transition, null, {
                  default: _withCtx(() => [
                    (_ctx.show)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_ctx.agentEvents.length === 0 && _ctx.agentMessageFormatted.length > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                                _createVNode(_component_v_icon, {
                                  color: "green",
                                  icon: "mdi-check-circle"
                                }),
                                _cache[2] || (_cache[2] = _createTextVNode(" All events completed "))
                              ]))
                            : (_ctx.agentEvents.length > 0)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agentEvents, ({ name, completed, started, finished }) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: `${name}-${completed}-${finished}`
                                    }, [
                                      completed
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            color: "green",
                                            icon: "mdi-check-circle"
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 1,
                                            color: "orange",
                                            icon: "mdi-progress-clock"
                                          })),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getEventLabel(name, completed)) + " ", 1),
                                      (!completed)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getTime(started)), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_7, "(" + _toDisplayString(_ctx.getTimeElapsed(started, finished)) + ")", 1))
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-6" }, [
                            _createElementVNode("strong", null, "Keep this page open until the analysis completes."),
                            _createTextVNode(" It typically takes 2 minutes or less."),
                            _createElementVNode("br"),
                            _createTextVNode(" If you have feedback or suggestions please send to "),
                            _createElementVNode("a", {
                              href: "mailto:feedback@stonkreport.com",
                              target: "_blank"
                            }, "feedback@stonkreport.com"),
                            _createTextVNode(" 🙏 ")
                          ], -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_card, {
          key: 1,
          class: "msg my-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.userLetter), 1)
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.userMessage), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createVNode(_component_v_card, { class: "msg" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            (_ctx.agentMessageFormatted !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_ctx.timestamp)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.getTime(_ctx.timestamp)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("pre", _hoisted_13, [
                    _createElementVNode("code", {
                      class: "chat-text language-markdown",
                      innerHTML: _ctx.agentMessageFormatted
                    }, null, 8, _hoisted_14)
                  ], 512)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[4] || (_cache[4] = [
                  _createElementVNode("div", { class: "typing" }, [
                    _createElementVNode("div", { class: "dot" }),
                    _createElementVNode("div", { class: "dot" }),
                    _createElementVNode("div", { class: "dot" })
                  ], -1)
                ])))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}